export default "__VITE_ASSET__24a349cd__"